// Initial Game State - used for React useState initialization
export const initialGameState = {
    currentProductIndex: 0,
    completedProducts: 0,
    soundEnabled: true,
    currentProduct: null,
    initialScreen: true,
    showModal: false,
    showHint: false,
    showSpark: false,
    showInstructions: false,
    showOnboarding: false,
    hintText: '',
    unlockedSlots: []
};
